/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyerformata53Inputs */

const en_checkinflyerformata53 = /** @type {(inputs: Checkinflyerformata53Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

const de_checkinflyerformata53 = /** @type {(inputs: Checkinflyerformata53Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A5`)
};

/**
* | output |
* | --- |
* | "A5" |
*
* @param {Checkinflyerformata53Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyerformata53 = /** @type {((inputs?: Checkinflyerformata53Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyerformata53Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyerformata53(inputs)
	return de_checkinflyerformata53(inputs)
});
export { checkinflyerformata53 as "checkinFlyerFormatA5" }